module.exports = __webpack_public_path__ + "img/2000_YR_2022_Email-top.a7afb437.png";